import React from 'react';

// MUI Icons
import SchoolIcon from '@mui/icons-material/School';
import VerifiedIcon from '@mui/icons-material/Verified';
import BadgeIcon from '@mui/icons-material/Badge';
import StarIcon from '@mui/icons-material/Star';

const Stats = () => {
  return (
    <div className="mx-auto md:max-w-xl lg:max-w-screen-xl grid gap-8 grid-cols-2 lg:grid-cols-4 mt-16">
      {/* Students Counseled */}
      <div className="text-center group transition-transform duration-300 hover:scale-105">
        <div className="flex items-center justify-center w-20 h-20 mx-auto mb-4 rounded-full bg-blue-50 shadow-md group-hover:bg-blue-100 transition-all duration-300">
          <SchoolIcon className="w-10 h-10 text-blue-600" />
        </div>
        <h6 className="text-3xl lg:text-4xl font-extrabold text-blue-600">25,000+</h6>
        <p className="text-sm mt-2 font-medium text-slate-500 tracking-wide">
          Students Counseled
        </p>
      </div>

      {/* Successfully Placed */}
      <div className="text-center group transition-transform duration-300 hover:scale-105">
        <div className="flex items-center justify-center w-20 h-20 mx-auto mb-4 rounded-full bg-rose-50 shadow-md group-hover:bg-rose-100 transition-all duration-300">
          <BadgeIcon className="w-10 h-10 text-rose-500" />
        </div>
        <h6 className="text-3xl lg:text-4xl font-extrabold text-rose-500">3,000+</h6>
        <p className="text-sm mt-2 font-medium text-slate-500 tracking-wide">
          Placed Successfully
        </p>
      </div>

      {/* Visa Success Rate */}
      <div className="text-center group transition-transform duration-300 hover:scale-105">
        <div className="flex items-center justify-center w-20 h-20 mx-auto mb-4 rounded-full bg-emerald-50 shadow-md group-hover:bg-emerald-100 transition-all duration-300">
          <VerifiedIcon className="w-10 h-10 text-emerald-600" />
        </div>
        <h6 className="text-3xl lg:text-4xl font-extrabold text-emerald-600">99%</h6>
        <p className="text-sm mt-2 font-medium text-slate-500 tracking-wide">
          Visa Success Rate
        </p>
      </div>

      {/* Years of Experience */}
      <div className="text-center group transition-transform duration-300 hover:scale-105">
        <div className="flex items-center justify-center w-20 h-20 mx-auto mb-4 rounded-full bg-amber-50 shadow-md group-hover:bg-amber-100 transition-all duration-300">
          <StarIcon className="w-10 h-10 text-amber-600" />
        </div>
        <h6 className="text-3xl lg:text-4xl font-extrabold text-amber-600">5+</h6>
        <p className="text-sm mt-2 font-medium text-slate-500 tracking-wide">
          Years of Experience
        </p>
      </div>
    </div>
  );
};

export default Stats;
